
export const decodeBase64 = (value: string): string =>
    TextDecoder
        ? new TextDecoder().decode(Uint8Array.from(window.atob(value), c => c.charCodeAt(0)))
        : window.atob(value);